export function flattenDimensions(nested) {
  let flatten = (dimOpts, result = []) => {
    dimOpts.forEach(o => {
      result = result.concat(o)
      if (o.values && o.values.length) result = result.concat(flatten(o.values))
    })
    return result
  }
  let flatOptions = Object.keys(nested.dimensionOptions).reduce((dict, dim) => {
    let tmp = flatten(nested.dimensionOptions[dim])
    tmp = tmp.filter((a, i) => tmp.findIndex(aa => aa.id === a.id) === i)
    dict[dim] = tmp
    return dict
  }, {})

  return { ...nested, dimensionOptions: flatOptions }
}

// probablemente se puede hacer sin el JSON.parse(JSON.stringify pero no esta claro
export function groupDimensions(nested) {
  let flat = flattenDimensions(nested)
  let flatOptions = JSON.parse(JSON.stringify(flat.dimensionOptions))
  flat.dimensions.forEach(dimid => {
    let grouped = Object.values(
      flatOptions[dimid].reduce((dict, item) => {
        dict[item.type] ||= { type: item.type, values: [] }
        dict[item.type].values.push(item)
        return dict
      }, {})
    )
    flatOptions[dimid] = grouped
  })
  return { ...flat, dimensionOptions: flatOptions }
}
export function userDimensions(nested) {
  return nested
}

import chartUtils from './chart'
export function getChartsAvailability(dimensions, charts, datacard) {
  return charts.map(c => {
    if (chartUtils[c.id] && chartUtils[c.id].getAvailability) {
      return { id: c.id, ...chartUtils[c.id].getAvailability(dimensions, datacard) }
    } else {
      console.warn(`chartUtils[${c.id}] not found !!`)
      return { id: c.id, enabled: false, enableable: false }
    }
  })
}

export function pickDefaultChart(dimensions, charts) {
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas
  let timeDim = Object.keys(dimOptions).find(key => metas[key]?.type === 'time')
  let timeOptions = timeDim && dimOptions[timeDim] && dimOptions[timeDim][0].values

  let locDim = Object.keys(dimOptions).find(key => metas[key]?.type === 'location')
  let locOptions = locDim && dimOptions[locDim] && dimOptions[locDim][0].values

  let chartId
  if (timeOptions && timeOptions.length) chartId = 'bar-chart'
  if (locOptions && locOptions.length > 1) {
    if (timeOptions && timeOptions < 3) chartId = 'bar-chart'
    else chartId = 'line-chart'
  }
  if (timeOptions && timeOptions.length < 4) chartId = 'bar-chart'
  else chartId = 'line-chart'

  if (!chartId) chartId = 'bar-chart'

  return charts.find(c => c.id === chartId)
}
export function createDefaultPivotConfig(dimensions, chart, previousValue, flatDimensionsOptions) {
  let newValue
  if (!chart) {
    newValue = createDefaultPivotConfig_table(dimensions)
  } else {
    let chartId = chart.id || chart
    if (chartId === 'map') newValue = chartUtils['map'].createDefaultPivotConfig(dimensions)
    else if (!chart.enabled) newValue = createEmptyConfig_chart(dimensions)
    else newValue = chartUtils[chartId].createDefaultPivotConfig(dimensions)
  }
  newValue.targetChart = chart?.id

  if (
    previousValue &&
    previousValue.targetChart &&
    previousValue.targetChart !== newValue.targetChart
  ) {
    newValue.dimensions.forEach(newDim => {
      let prevDim = previousValue.dimensions.find(d => d.id === newDim.id)
      if (prevDim) {
        if (prevDim.role === 'filters' && newDim.role === 'filters') {
          // SI son filters->filters COPIAMOS sin duda
          newDim.values = prevDim.values
        } else if (prevDim.role !== 'filters' && newDim.role !== 'filters') {
          // SI son otra cosa (rows/columns/chart)
          let prevType = previousValue.dimensions.find(d => d.id === prevDim.id + '_type')
          let newType = newValue.dimensions.find(d => d.id === newDim.id + '_type')
          if (prevType && newType) {
            // SOLO SI TIENEN TYPE:
            if (
              JSON.stringify(prevType.values.map(t => t.value)) ===
              JSON.stringify(newType.values.map(t => t.value))
            ) {
              // SI el type no ha cambiado, copiamos valores
              newDim.values = prevDim.values
            } else {
              let prevAvailableValues = flatDimensionsOptions[prevDim.id].filter(o =>
                prevType.values.find(v => v.value === o.type)
              )
              if (prevDim.values.length !== prevAvailableValues.length) {
                // SI el type HA CAMBIADO y NO ESTABAN "all selected" tambien copiamos valores
                newType.values = prevType.values
                newDim.values = prevDim.values
              }
            }
          }
        }
      }
    })
  }
  return newValue
}
function createEmptyConfig_chart(dimensions) {
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas
  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      return {
        id: key,
        role: 'filters',
      }
    }),
  }
  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })
  setDefaultValues(pivotConfig.dimensions, dimOptions, metas)

  return pivotConfig
}
function createDefaultPivotConfig_table(dimensions) {
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas
  let pivotConfig
  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'time' ? 'columns' : type === 'location' ? 'rows' : 'filters'
      return {
        id: key,
        role: role,
      }
    }),
  }

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas)

  let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
    // let filterDims = pivotConfig.dimensions.filter(
    //   d => d.role === 'filters' && dimOptions[d.id].length > 1
    // )
    // if (filterDims.length > 0) {
    //   filterDims = filterDims.slice(0, 1)
    //   filterDims.forEach(d => (d.role = 'rows'))
    rowsDim.role = 'filters'
    // } else {
    //   let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
    //   rowsDim.role = 'columns'
    //   colsDim.role = 'rows'
    // }
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
  }

  //RELLENAMOS ROWS Y COLS

  let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let filetrsDims = pivotConfig.dimensions.filter(
    d => d.role === 'filters' && dimOptions[d.id].length > 1
  )
  let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let toRows, toCols

  filetrsDims.forEach((el, i) => {
    if (i % 2 === 0 && rowsDims.length < 2) {
      toRows = [el]
      toRows.forEach(d => (d.role = 'rows'))
      setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
    } else if (i % 2 === 0 && colsDims.length < 2) {
      toCols = [el]
      toCols.forEach(d => (d.role = 'columns'))
      setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
    } else if (i % 2 !== 0 && colsDims.length < 2) {
      toCols = [el]
      toCols.forEach(d => (d.role = 'columns'))
      setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
    } else if (i % 2 !== 0 && rowsDims.length < 2) {
      toRows = [el]
      toRows.forEach(d => (d.role = 'rows'))
      setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
    }
  })
  setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
  // if (rowsDims.length === 0 && filetrsDims.length > 0) {
  //   toRows = filetrsDims.slice(0, 2 - rowsDims.length)
  //   toRows.forEach(d => (d.role = 'rows'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
  // }
  // filetrsDims = pivotConfig.dimensions.filter(
  //   d => d.role === 'filters' && dimOptions[d.id].length > 1
  // )
  // if (colsDims.length === 1 && filetrsDims.length > 0) {
  //   toCols = filetrsDims.slice(0, 2 - colsDims.length)
  //   toCols.forEach(d => (d.role = 'columns'))
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas)
  // }
  return pivotConfig
}

export function setToTopDimIds(pivotConfig, metas, minChildren = 1) {
  let typeDims = pivotConfig.dimensions.filter(dim => dim.role === 'types')
  typeDims.forEach(dim => {
    let dimName = dim.id.replace('_type', '')
    let allValues = pivotConfig.dimensions.find(d => d.id === dimName).values
    // Buscamos el de mas arriba con datos y con hijos
    let topDim = metas[dimName].typeOptions.find(td => {
      return td.count > 0 && allValues.filter(v => v.type === td.id).length > minChildren
    })
    //Buscamos el de mas arriba con hijos
    if (!topDim) {
      topDim = metas[dimName].typeOptions.find(td => {
        return td.count > 0 && allValues.filter(v => v.type === td.id).length > 0
      })
    }
    // sino ponemos el "primero"
    let bestDimId = topDim ? topDim.id : dim.values[0].value

    dim.values = dim.values.filter(d => d.value === bestDimId)
  })
}
function optToValue(o) {
  return {
    value: o.id,
    type: o.type,
  }
}
export function setDefaultValues(dimensions, dimOptions, metas) {
  dimensions.forEach(d => {
    let key = d.id
    if (key.indexOf('_type') > 0) {
      d.values.forEach(e => {
        let metaOp = metas[key.replace('_type', '')].typeOptions.find(
          el => el.type === e.type
        )?.label
        return (e['labelType'] = metaOp ? metaOp.charAt(0).toUpperCase() + metaOp.slice(1) : e.type)
      })
      return
    }
    if (metas[key].type === 'location' || metas[key].type === 'time') {
      // ESTO AUSME QUE la location es barcelona>districtes...
      // NOTE: el "type=time" siempre es single select!!
      let typeDim = dimensions.find(dd => dd.id === key + '_type')
      if (!typeDim.values) {
        //Si ya se han seteado typeDim.values, cumplicos con las restircciones, no?!
        if (metas[key].type === 'location') typeDim.values = metas[key].typeOptions.map(optToValue)
        else typeDim.values = metas[key].typeOptions.slice(0, 1).map(optToValue)
      }
      d.values = []
      let fillSubValues = node => {
        //Creo que es redundatne el "node.id!=='period'" poque NUNCA estara el type=period
        if (node.id !== 'period' && typeDim.values.find(t => t.type === node.type))
          d.values.push(optToValue(node))
        if (node.values) {
          node.values.forEach(v => fillSubValues(v))
        }
      }
      // fillSubValues(dimOptions[key][0])
      if (d.role === 'filters') {
        if (metas[key].type === 'time') {
          if (dimOptions[key][0].values && dimOptions[key][0].values.length) {
            //Default: last available time
            d.values = dimOptions[key][0].values.map(optToValue).slice(-1)
          } else {
            d.values = [optToValue(dimOptions[key][0])]
          }
        } else {
          // NEVER TESTED
          if (metas[key].type === 'location' && dimOptions[key][0].id) {
            d.values = [optToValue(dimOptions[key][0].id)]
          } else if (dimOptions[key][0].values && dimOptions[key][0].values.length) {
            d.values = dimOptions[key][0].values.map(optToValue).slice(0, 1)
          } else {
            d.values = [optToValue(dimOptions[key][0])]
          }
        }
      } else {
        dimOptions[key].forEach(dos => {
          fillSubValues(dos)
        })
      }
      // } else d.values = []
      // }
    } else {
      if (d.role === 'filters') {
        d.values = dimOptions[key].map(optToValue).slice(0, 1)
      } else {
        d.values = dimOptions[key].map(optToValue)
      }
    }
  })
  // Seteamos index: iniciales,
  // Intentamos respetar los "index" que ya se hayan seteado (como en pyramidChartUtils)
  dimensions.forEach(d => {
    if (d.index === undefined) d.index = Infinity
  })
  dimensions.sort((a, b) => a.index - b.index)
  dimensions.forEach((d, j) => {
    d.values.forEach((v, i) => {
      v.index = i
    })
    d.index = j
  })
}
